<template>
  <div class="wrap">
    <div class="form_box">
      <!-- <div class="head_img">
        <img class="logo" src="@/assets/images/logo_new.png" alt="" />
      </div> -->
      <div class="form">
        <el-form :model="params" :rules="rules" ref="ruleForm">
          <el-form-item prop="username">
            <el-input
              class="input"
              placeholder="请输入手机号"
              v-model.number="params.username"
              :maxlength="11"
            >
              <img
                class="left_icon"
                slot="prefix"
                src="@/assets/images/icons/icon_loginName.png"
                alt=""
              />
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              class="input"
              placeholder="请输入密码"
              v-model="params.password"
              show-password
            >
              <img
                class="left_icon"
                slot="prefix"
                src="@/assets/images/icons/icon_password.png"
                alt=""
              />
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input
              class="input"
              maxlength="4"
              placeholder="请输入验证码"
              v-model="params.code"
            >
              <img
                class="left_icon"
                slot="prefix"
                src="@/assets/images/icons/icon_phone.png"
                alt=""
              />
              <img
                slot="suffix"
                class="captcha"
                :src="codeImg"
                @click="getCaptcha"
              />
            </el-input>
          </el-form-item>
        </el-form>
        <!-- <div class="remember_row">
          <div class="remember">
            <el-checkbox v-model="remember">自动登录</el-checkbox>
          </div>
          <el-button class="forget_pass" type="text" @click="show = true"
            >忘记密码?</el-button
          >
        </div> -->
        <el-button
          class="login_btn"
          type="primary"
          size="medium"
          @click="handleLogin('ruleForm')"
          :loading="loading"
          style="background: teal; border-color: teal"
          >{{ loading ? "登录中..." : "登 录" }}</el-button
        >
        <p class="go_register">
          没有账号？
          <span @click="$router.push('/register')">去注册</span>
        </p>
      </div>
    </div>
    <!-- <div class="bottom_nav">
      <div class="nav">
        <span
          class="nav_item"
          v-for="item in navs"
          :key="item.id"
          @click="$router.push(item.name)"
          >{{ item.label }}</span
        >
      </div>
      <p>copyright©2021厦门易普道信息科技有限公司</p>
    </div> -->

    <el-dialog title="重置密码" :visible.sync="show" width="40%" center>
      <el-steps :active="activeStep" align-center finish-status="success">
        <el-step title="验证账号"></el-step>
        <el-step title="填写密保问题"></el-step>
        <el-step title="设置新密码"></el-step>
      </el-steps>
      <div
        v-show="activeStep == 0"
        style="margin-top: 30px; text-align: center"
      >
        <el-input
          class="account-input"
          placeholder="请输入账号"
          v-model="account"
          :maxlength="11"
        ></el-input>
      </div>
      <div class="questions" v-show="activeStep == 1">
        <div
          class="one"
          v-for="(item, idx) in originalQuestions"
          :key="item.id"
        >
          <div style="line-height: 32px">
            问题{{ idx + 1 }}:
            <span class="question-text">{{ item.question }}</span>
          </div>
          <div style="padding-left: 8px; margin-top: 10px">
            答案:
            <el-input
              class="answer-input"
              v-model="item.answer"
              placeholder="请输入答案"
              size="small"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="success" v-show="activeStep == 2">
        <el-input
          class="pass-input"
          type="password"
          v-model="newPassword"
          autocomplete="off"
          show-password
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="show = false">取 消</el-button>
        <el-button type="primary" size="medium" @click="handleSubmit">{{
          activeStep == 2 ? "提交" : "下一步"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { login, captcha } from "@/api/login";
import {
  userQuestion,
  userVerQuestion,
  resetPass,
} from "@/api/securityQuestion";

export default {
  name: "login",
  data() {
    var checkUser = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      }
      if (!Number.isInteger(value)) {
        callback(new Error("请输入数字"));
      }
      if (String(value).length < 11) {
        callback(new Error("手机号格式错误"));
      } else {
        callback();
      }
    };
    return {
      navs: [
        {
          id: "1",
          label: "首页",
          name: "home",
        },
        {
          id: "2",
          label: "隐私",
          name: "home",
        },
        {
          id: "3",
          label: "条款",
          name: "home",
        },
      ],
      params: {
        username: "",
        password: "",
        codeId: "",
        code: "",
      },
      rules: {
        username: { validator: checkUser, trigger: "blur" },
        password: {
          required: true,
          message: "请输入密码",
          trigger: "blur",
        },
        code: {
          required: true,
          message: "请输入验证码",
          trigger: "blur",
        },
      },
      remember: true,
      codeImg: "",
      loading: false,
      show: false,
      activeStep: 0,
      originalQuestions: [],
      account: "",
      newPassword: "",
    };
  },
  created() {
    this.getCaptcha();
  },
  methods: {
    // 图形码
    getCaptcha() {
      captcha().then((res) => {
        if (res.code == 0) {
          this.codeImg = res.data.codeImg;
          this.params.codeId = res.data.codeId;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          login(this.params).then((res) => {
            this.loading = false;
            if (res.code == 0) {
              if (this.remember)
                localStorage.setItem("Authorization", res.data);
              else sessionStorage.setItem("Authorization", res.data);
              this.$store.commit("SET_LOGIN", true);
              this.$message.success("登录成功");
              this.$router.push("/home");
            } else {
              this.$message.error(res.msg);
              this.getCaptcha();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSubmit() {
      if (this.activeStep == 0) {
        if (!this.account) {
          this.$message.warning("请填写您要找回密码的账号");
          return;
        }
        userQuestion({ username: this.account }).then(({ code, data, msg }) => {
          if (code == 0) {
            this.originalQuestions = data;
            this.activeStep++;
          } else {
            this.$message.error(msg);
          }
        });
      } else if (this.activeStep == 1) {
        userVerQuestion({
          username: this.account,
          answerList: this.originalQuestions,
        }).then(({ code, data, msg }) => {
          if (code == 0) {
            if (data) this.activeStep++;
            else this.$message.error("题目回答有误");
          } else {
            this.$message.error(msg);
          }
        });
      } else {
        this.$loading.show();
        resetPass({
          username: this.account,
          password: this.newPassword,
        }).then(({ code, msg }) => {
          this.$loading.hide();
          if (code == 0) {
            this.$message.success("重置密码成功");
            this.show = false;
          } else {
            this.$message.error(msg);
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  position: relative;
  padding-top: 120px;
  padding-bottom: 40px;
  // min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/images/bg.jpg");
  background-size: cover;
  .form_box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    // margin: 0 auto;
    padding: 30px 45px;
    width: 450px;
    // height: 580px;
    background: #ffffff;
    border-radius: 20px;
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.31);

    .head_img {
      margin-bottom: 30px;
      text-align: center;
      .logo {
        width: 230px;
        // height: 102px;
      }
    }

    .form {
      ::v-deep .input {
        .left_icon {
          margin-left: 5px;
          width: 20px;
          height: 20px;
        }
        .el-input__inner {
          padding-left: 35px;
          // height: 33px;
        }
        .el-input__suffix {
          right: 0;
        }
      }

      .captcha {
        height: 40px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        cursor: pointer;
      }
      .remember_row {
        margin-bottom: 15px;
        overflow: hidden;

        .remember {
          float: left;
        }

        .forget_pass {
          padding: 0;
          float: right;
        }
      }

      .login_btn {
        margin-bottom: 20px;
        width: 100%;
        font-size: 18px;
      }

      .go_register {
        text-align: center;
        span {
          color: teal;
          cursor: pointer;
        }
      }
    }
  }

  .bottom_nav {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    color: #fff;

    .nav {
      margin-bottom: 20px;

      .nav_item {
        display: inline-block;
        margin: 0 32px;
        transition: all 0.3s ease;
        cursor: pointer;

        &:hover {
          color: #dbdbdb;
        }
      }
    }
  }
  .account-input,
  .pass-input {
    width: 215px;
  }
  .questions {
    margin-top: 30px;
    text-align: center;
    .one {
      margin-bottom: 30px;
      .question-text {
        display: inline-block;
        width: 215px;
        text-align: left;
      }
      .answer-input {
        width: 215px;
      }
    }
  }

  .success {
    margin-top: 30px;
    text-align: center;
    .tips {
      font-size: 16px;
      font-weight: bold;
      color: #000;
    }
    .password {
      margin-top: 30px;
      font-weight: bold;
      font-size: 28px;
      color: #1890ff;
    }
  }
}
</style>
